export default __webpack_public_path__ + "static/media/sabonBoldItalic.9f8f61fd.ttf";